import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { hideLoading, notifyError, showLoading } from '../../shared/notify.js';

// Reveals the passkey panel and puts the password fields beyond reach, so the
// page says plainly which step it is on. The fields stay rendered rather than
// removed: the MFA token can expire, and the message then tells the user to
// start again on a form that is still there.
function zweitenSchrittZeigen(form) {
  const panel = document.getElementById('passkey-schritt');
  if (!panel) return;

  panel.classList.remove('hidden');
  form.querySelectorAll('input, button[type="submit"]').forEach((feld) => {
    feld.disabled = true;
  });

  const fortsetzen = document.getElementById('passkey-fortsetzen');
  if (fortsetzen) fortsetzen.focus();
}

export function initLogin() {
  const form = document.getElementById('login-form');
  if (!form) return;

  const submitButton = form.querySelector('button[type="submit"]');

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());

    if (submitButton) submitButton.disabled = true;
    showLoading('Anmeldung läuft …');

    try {
      const antwort = await http.post('/auth/login', data);

      // The password was right but the account finishes with a passkey. No
      // session was granted, so this reveals the second step in place rather
      // than navigating - a page change here would risk the five-minute
      // ceremony.
      if (antwort.data?.data?.mfa === 'passkey') {
        hideLoading();
        if (submitButton) submitButton.disabled = false;
        zweitenSchrittZeigen(form);
        return;
      }

      // The overlay stays up until the dashboard takes over; the success toast
      // is handed to the next page through the URL.
      window.location.href = withFlash('/', 'angemeldet');
    } catch (err) {
      hideLoading();
      if (submitButton) submitButton.disabled = false;
      notifyError(
        err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
      );
    }
  });
}
